/*下钻工具*/

import drillDown from "./drillDown"/*下钻组件*/
import drillDownConfig from "./drillDownConfig"/*下钻组件*/
import xiazuanConfig from "./drillDownConfig"

let drillDowmObj = ''/*下钻实例*/

/**
 * 激活下钻功能
 */
let activeDrillDown = (map,options,func_optios) => {
  if(drillDowmObj){
    drillDowmObj.active(map, options,func_optios);
  }else{
    drillDowmObj = new drillDown()
    drillDowmObj.active(map, options,func_optios);
  }
}

/*通过下载工具来进行行政区高亮*/
let hilight_dirll_down = (qhdm) => {
  if(drillDowmObj){
    drillDowmObj.do_init_hilight(qhdm);
  }
}

/*重置下钻*/
let re_do_drilldown = () => {
  if(drillDowmObj){
    drillDowmObj.re_do();
  }
}

/**
 * 卸载下钻功能
 */
let inActiveDrillDown = (options) => {
  if(drillDowmObj){
    drillDowmObj.inActive(options);
  }
}

let setConfig = function(levelName,sourceVersion){
  xiazuanConfig.xzqLayer.forEach((item,index)=>{
    if(item.levelName==levelName&&sourceVersion=='2019'){
      item.layerId = "县级行政区2019年"
      item.sourceId = "xzq_xj"
      item.sourceLayer = "xzq_xj"
      item.sourceId_pt = "xzq_xj_pt"
      item.sourceLayer_pt = "xzq_xj_pt"
    }else{
      item.layerId = "县级行政区2022年"
      item.sourceId = "xzq_xj_20221"
      item.sourceLayer = "xzq_xj_20221"
      item.sourceId_pt = "xzq_xj_20221_pt"
      item.sourceLayer_pt = "xzq_xj_20221_pt"
    }
  })
}

export default {
  activeDrillDown,
  re_do_drilldown,
  inActiveDrillDown,
  hilight_dirll_down,
  setConfig

}



// WEBPACK FOOTER //
// ./src/assets/js/drillDown/drilldown_tool.js